import React from 'react';

import {
  CONDITIONAL_SELECT,
  CONDITIONAL_TEXT_FIELD,
  PALETTE_MAPPING,
  RADIO,
  REPORT_CONTROL_TYPE,
  SELECT,
} from './report-designer.constants';
import SquareIcon from '../components/SquareIcon';

export const SORT_DIRECTION_VALUES = [
  {
    value: 'ASC',
    label: 'Ascending',
  },
  {
    value: 'DESC',
    label: 'Descending',
  },
];

const PALETTE_VALUES = [
  {
    value: 'Default',
    label: 'Default',
    icon: <SquareIcon color={PALETTE_MAPPING.Default} />,
  },
  {
    value: 'Excel',
    label: 'Excel',
    icon: <SquareIcon color={PALETTE_MAPPING.Excel} />,
  },
  {
    value: 'EarthTones',
    label: 'Earth Tones',
    icon: <SquareIcon color={PALETTE_MAPPING.EarthTones} />,
  },
  {
    value: 'Pastel',
    label: 'Pastel',
    icon: <SquareIcon color={PALETTE_MAPPING.Pastel} />,
  },
  {
    value: 'SemiTransparent',
    label: 'Semi Transparent',
    icon: <SquareIcon color={PALETTE_MAPPING.SemiTransparent} />,
  },
];

const LEGEND_PLACEMENT_VALUES = [
  {
    value: true,
    label: 'Inside Plot Area',
  },
  {
    value: false,
    label: 'Outside Plot Area',
  },
];

const LEGEND_LAYOUT_VALUES = [
  {
    value: 'Column',
    label: 'Column',
  },
  {
    value: 'Row',
    label: 'Row',
  },
  {
    value: 'Table',
    label: 'Table',
  },
];

export const FILTER_VALUES = [
  {
    value: 'UserContext.UserCode',
    label: 'User Logon Code',
  },
  {
    value: 'UserContext.ActorCode',
    label: 'User Code',
  },
  {
    value: 'UserContext.ActorId',
    label: 'User Internal Id',
  },
  {
    value: 'UserContext.LoggedOnOrgId',
    label: 'Logged On Organization Id',
  },
  {
    value: 'UserContext.LoggedOnRoleId',
    label: 'Logged On Role Id',
  },
  {
    value: 'UserContext.OrgUnitId',
    label: 'User Department Id',
  },
  {
    value: 'usercontext.sitesaccess',
    label: 'User Sites Access',
  },
  {
    value: 'AddDays(0)',
    label: 'AddDays(#)',
  },
  {
    value: 'YearToDate',
    label: 'YearToDate',
  },
  {
    value: 'MonthToDate',
    label: 'MonthToDate',
  },
  {
    value: 'TrailingMonths(1)',
    label: 'TrailingMonths(#)',
  },
  {
    value: '{|Param|}',
    label: '{|Param|}',
  },
];

const SHOW_FILTER_VALUES = [
  {
    value: 'none',
    label: 'None',
  },
  {
    value: 'firstPage',
    label: 'First page only',
  },
  {
    value: 'lastPage',
    label: 'Last page only',
  },
  {
    value: 'everyPage',
    label: 'Every page',
  },
];

const PAGE_HEADER_HEIGHT_VALUES = [
  {
    value: '1',
    label: 'Small',
  },
  {
    value: '2',
    label: 'Medium',
  },
  {
    value: '3',
    label: 'Large',
  },
];

const CHART_HEIGHT_VALUES = [
  {
    value: '2',
    label: 'Small',
  },
  {
    value: '4',
    label: 'Medium',
  },
  {
    value: '6',
    label: 'Large',
  },
];

const YES_NO_VALUES = [
  {
    value: true,
    label: 'Yes',
  },
  {
    value: false,
    label: 'No',
  },
];

const DATA_FILTER_CONDITION_VALUES = [
  {
    value: 'EQ',
    label: 'Equals To',
  },
  {
    value: 'SW',
    label: 'Starts With',
  },
  {
    value: 'GT',
    label: 'Greater Than',
  },
  {
    value: 'GTEQ',
    label: 'Greater Than Equal To',
  },
  {
    value: 'LT',
    label: 'Less Than',
  },
  {
    value: 'LTEQ',
    label: 'Less Than Equal To',
  },
  {
    value: 'NEQ',
    label: 'Does Not Equal To',
  },
];

export const CONDITION_VALUES = [
  ...DATA_FILTER_CONDITION_VALUES,
  {
    value: 'ISNULL',
    label: 'Is Null',
  },
  {
    value: 'ISNOTNULL',
    label: 'Is Not Null',
  },
  {
    value: 'IN',
    label: 'In',
  },
];

export const OPEN_GROUP_VALUES = [
  {
    value: '',
    label: 'None',
  },
  {
    value: '(',
    label: '(',
  },
];

export const CLOSE_GROUP_VALUES = [
  {
    value: '',
    label: 'None',
  },
  {
    value: ')',
    label: ')',
  },
];

export const OPERATOR_VALUES = [
  {
    value: 'and',
    label: 'And',
  },
  {
    value: 'or',
    label: 'Or',
  },
  {
    value: '',
    label: 'None',
  },
];

export const VALIDATION_VALUES = [
  {
    value: 'SkipBlank',
    label: 'Skip Blank Value',
  },
  {
    value: 'NoBlank',
    label: 'Require Value',
  },
];

const VALUE_TYPE_VALUES = [
  {
    value: 'Count',
    label: 'Count',
  },
  {
    value: 'Sum',
    label: 'Sum',
  },
  {
    value: 'Avg',
    label: 'Average',
  },
  {
    value: 'Max',
    label: 'Max',
  },
  {
    value: 'Min',
    label: 'Min',
  },
  {
    value: 'other',
    label: 'Other',
  },
];

const GROUP_SUMMARY_TYPE_VALUES = [
  {
    value: 'Count',
    label: 'Count',
  },
  {
    value: 'Sum',
    label: 'Sum',
  },
  {
    value: 'Avg',
    label: 'Average',
  },
  {
    value: 'Max',
    label: 'Max',
  },
  {
    value: 'Min',
    label: 'Min',
  },
  {
    value: 'other',
    label: 'Other',
  },
  {
    value: 'none',
    label: 'None',
  },
];

export const CHART_TYPE_VALUES = [
  {
    value: 'Column',
    label: 'Column chart',
  },
  {
    value: 'StackedColumn',
    label: 'Stacked column chart',
  },
  {
    value: 'PercentStackedColumn',
    label: '100% stacked column chart',
  },
  {
    value: 'Bar',
    label: 'Bar chart',
  },
  {
    value: 'StackedBar',
    label: 'Stacked bar chart',
  },
  {
    value: 'PercentStackedBar',
    label: '100% stacked bar chart',
  },
  {
    value: 'Line',
    label: 'Line chart',
  },
  {
    value: 'SmoothLine',
    label: 'Smooth line chart',
  },
  {
    value: 'Pie',
    label: 'Pie chart',
  },
  {
    value: 'ExplodedPie',
    label: 'Exploded pie chart',
  },
  {
    value: 'Scatter',
    label: 'XY scatter chart',
  },
  {
    value: 'LineScatter',
    label: 'Scatter with data points connected by lines',
  },
  {
    value: 'SmoothLineScatter',
    label: 'Scatter with data points connected by smoothed lines',
  },
  {
    value: 'Area',
    label: 'Area chart',
  },
  {
    value: 'StackedArea',
    label: 'Stacked area chart',
  },
  {
    value: 'PercentStackedArea',
    label: '100% stacked area chart',
  },
  {
    value: 'Doughnut',
    label: 'Doughnut chart',
  },
  {
    value: 'ExplodedDoughnut',
    label: 'Exploded doughnut chart',
  },
];

const LEGEND_POSITION_VALUES = [
  {
    value: 'RightCenter',
    label: 'Right Center',
  },
  {
    value: 'RightTop',
    label: 'Right Top',
  },
  {
    value: 'RightBottom',
    label: 'Right Bottom',
  },
  {
    value: 'BottomLeft',
    label: 'Bottom Left',
  },
  {
    value: 'BottomCenter',
    label: 'Bottom Center',
  },
  {
    value: 'BottomRight',
    label: 'Bottom Right',
  },
  {
    value: 'LeftTop',
    label: 'Left Top',
  },
  {
    value: 'LeftCenter',
    label: 'Left Center',
  },
  {
    value: 'LeftBottom',
    label: 'Left Bottom',
  },
  {
    value: 'TopLeft',
    label: 'Top Left',
  },
  {
    value: 'TopCenter',
    label: 'Top Center',
  },
  {
    value: 'TopRight',
    label: 'Top Right',
  },
];

const COLUMN_EXPAND_DIRECTION_VALUES = [
  {
    value: 'LTR',
    label: 'Left To Right',
  },
  {
    value: 'RTL',
    label: 'Right To Left',
  },
];

const DYNAMIC_CELL_VALUES = [
  {
    value: 'column',
    label: 'Column',
  },
  {
    value: 'row',
    label: 'Row',
  },
];

const THEME_VALUES = [
  {
    value: '1',
    label: 'Solitude',
  },
  {
    value: '2',
    label: 'Light Blue',
  },
  {
    value: '3',
    label: 'Blue',
  },
  {
    value: '4',
    label: 'Transparent',
  },
];
const PAGE_WIDTH_VALUES = [
  {
    value: '11',
    label: 'Legal-Landscape',
  },
  {
    value: '8.5',
    label: 'Legal-Portrait',
  },
  {
    value: '11.69',
    label: 'A4-Landscape',
  },
  {
    value: '8.27',
    label: 'A4-Portrait',
  },
  {
    value: '2',
    label: 'Dashboard-Small',
  },
  {
    value: '4',
    label: 'Dashboard-Medium',
  },
  {
    value: '6',
    label: 'Dashboard-Large',
  },
];

const PAGE_HEIGHT_VALUES = [
  {
    value: '11',
    label: 'Legal-Portrait',
  },
  {
    value: '8.5',
    label: 'Legal-Landscape',
  },
  {
    value: '11.69',
    label: 'A4-Portrait',
  },
  {
    value: '8.27',
    label: 'A4-Landscape',
  },
  {
    value: '2',
    label: 'Dashboard-Small',
  },
  {
    value: '4',
    label: 'Dashboard-Medium',
  },
  {
    value: '6',
    label: 'Dashboard-Large',
  },
];

const TREND_THEME_VALUES = [
  {
    value: '1',
    label: 'Light Blue',
  },
  {
    value: '2',
    label: 'Blue',
  },
  {
    value: '3',
    label: 'Black',
  },
];

const MARKER_TYPE_VALUES = [
  {
    value: 'None',
    label: 'None',
  },
  {
    value: 'Diamond',
    label: 'Diamond',
  },
  {
    value: 'Circle',
    label: 'Circle',
  },
  {
    value: 'Cross',
    label: 'Cross',
  },
  {
    value: 'Square',
    label: 'Square',
  },
  {
    value: 'Triangle',
    label: 'Triangle',
  },
];

const FORMAT_CONDITIONAL_VALUES = [
  {
    value: 'none',
    label: 'None',
  },
  {
    value: 'MM-dd-yy',
    label: 'MM-DD-YY',
  },
  {
    value: 'dd-MM-yy',
    label: 'DD-MM-YY',
  },
  {
    value: 'yyyy-MMM-dd',
    label: 'YYYY-MMM-dd',
  },
  {
    value: 'MMM-dd-yyyy',
    label: 'MMM-DD-YYYY',
  },
  {
    value: 'MM-dd-yy HH:mm:ss',
    label: 'MM-DD-YY HH:MM:SS',
  },
  {
    value: 'dd-MM-yy HH:mm:ss',
    label: 'DD-MM-YY HH:MM:SS',
  },
  {
    value: 'dd-MMM-yyyy HH:mm:ss',
    label: 'DD-MMM-YYYY HH:MM:SS',
  },
  {
    value: 'conditional',
    label: 'Conditional...',
  },
];

const COLOR_CONDITIONAL_VALUES = [
  {
    value: 'none',
    label: 'None',
  },
  {
    value: '#FF0000',
    label: 'Red',
    icon: <SquareIcon color="#ff0000" />,
  },
  {
    value: '#00FF00',
    label: 'Green',
    icon: <SquareIcon color="#00ff00" />,
  },
  {
    value: '#0000FF',
    label: 'Blue',
    icon: <SquareIcon color="#0000ff" />,
  },
  {
    value: '#FFFFFF',
    label: 'White',
    icon: <SquareIcon />,
  },
  {
    value: '#000000',
    label: 'Black',
    icon: <SquareIcon color="#000000" />,
  },
  {
    value: '#FF00CC',
    label: 'Pink',
    icon: <SquareIcon color="#ff00cc" />,
  },
  {
    value: '#0066FF',
    label: 'Light Blue',
    icon: <SquareIcon color="#0066ff" />,
  },
  {
    value: '#66FF00',
    label: 'Light Green',
    icon: <SquareIcon color="#66ff00" />,
  },
  {
    value: '#C0C0C0',
    label: 'Gray',
    icon: <SquareIcon color="#c0c0c0" />,
  },
  {
    value: 'conditional',
    label: 'Conditional...',
    icon: <SquareIcon />,
  },
];

const FONT_FAMILY_CONDITIONAL_VALUES = [
  {
    value: 'none',
    label: 'None',
  },
  {
    value: 'Tahoma',
    label: 'Tahoma',
  },
  {
    value: 'Times New Roman',
    label: 'Times New Roman',
  },
  {
    value: 'Trebuchet MS',
    label: 'Trebuchet MS',
  },
  {
    value: 'conditional',
    label: 'Conditional...',
  },
];

export const YES_NO_CONDITIONAL_VALUES = [
  ...YES_NO_VALUES,
  { value: 'conditional', label: 'Conditional...' },
];

const DATA_MEMBER = {
  label: 'Data Member',
  type: SELECT,
  name: 'dataMember',
};

const CHART_TYPE = {
  label: 'Chart Type',
  type: SELECT,
  values: CHART_TYPE_VALUES,
  name: 'chartType',
};

const TITLE = {
  label: 'Title',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'label',
};

const MATRIX_TITLE = {
  label: 'Title',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'matrixTitle',
};

const GROUP_BY_COLUMN = {
  label: 'Group By',
  type: CONDITIONAL_SELECT,
  name: 'groupByColumn',
  entitySourceField: DATA_MEMBER.name,
};

const PAGE_HEADER_HEIGHT = {
  label: 'Height',
  values: PAGE_HEADER_HEIGHT_VALUES,
  type: SELECT,
  name: 'height',
};

const CHART_HEIGHT = {
  label: 'Height',
  values: CHART_HEIGHT_VALUES,
  type: SELECT,
  name: 'height',
};

const SHOW_LEGEND = {
  label: 'Show Legend',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'showLegend',
};

const LEGEND_LAYOUT = {
  label: 'Legend Layout',
  values: LEGEND_LAYOUT_VALUES,
  type: SELECT,
  name: 'legendLayout',
};

const LEGEND_PLACEMENT = {
  label: 'Legend Placement',
  values: LEGEND_PLACEMENT_VALUES,
  type: SELECT,
  name: 'insidePlotArea',
};

const LEGEND_POSITION = {
  label: 'Legend Position',
  type: SELECT,
  values: LEGEND_POSITION_VALUES,
  name: 'legendPosition',
};

const PALETTE = {
  label: 'Palette',
  values: PALETTE_VALUES,
  type: SELECT,
  name: 'palette',
};

const SHOW_GRID_LINE = {
  label: 'Show Grid Line',
  values: YES_NO_CONDITIONAL_VALUES,
  type: CONDITIONAL_SELECT,
  name: 'showGridLines',
};

const ENABLE_3D = {
  label: 'Enable 3D',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'threeDEffect',
};

const DYNAMIC_SERIES = {
  label: 'Dynamic Series',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'dynamicSeries',
};

const SERIES_VALUE = {
  label: 'Series Value',
  type: CONDITIONAL_SELECT,
  name: 'dataField',
  entitySourceField: DATA_MEMBER.name,
};

const SORT_DIRECTION = {
  label: 'Sort Direction',
  type: SELECT,
  values: SORT_DIRECTION_VALUES,
  name: 'sort',
};

const DATA_FIELD = {
  label: 'Data Field',
  type: CONDITIONAL_SELECT,
  name: 'dataField',
  entitySourceField: DATA_MEMBER.name,
};

const CONDITIONAL_DATA_FIELD = {
  label: 'Data Field',
  type: CONDITIONAL_SELECT,
  name: 'dataField',
  entitySourceField: DATA_MEMBER.name,
};

const LABEL = {
  label: 'Label',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'label',
};

const TRANSLATED_LABEL = {
  label: 'Translate Label',
  values: YES_NO_CONDITIONAL_VALUES,
  type: CONDITIONAL_SELECT,
  name: 'translateLabel',
};

const LINK = {
  label: 'Link',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'link',
};

const WIDTH = {
  label: 'Width',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'width',
};

const FORMAT = {
  label: 'Format',
  type: CONDITIONAL_SELECT,
  values: FORMAT_CONDITIONAL_VALUES,
  name: 'format',
};

const COLOR = {
  label: 'Color',
  type: CONDITIONAL_SELECT,
  values: COLOR_CONDITIONAL_VALUES,
  name: 'color',
};

const BACKGROUND_COLOR = {
  label: 'Background Color',
  type: CONDITIONAL_SELECT,
  values: COLOR_CONDITIONAL_VALUES,
  name: 'backGroundColor',
};

const FONT_FAMILY = {
  label: 'Font Family',
  type: CONDITIONAL_SELECT,
  values: FONT_FAMILY_CONDITIONAL_VALUES,
  name: 'fontFamily',
};

const IMAGE_URL = {
  label: 'Image Url',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'imageURL',
};

const CATEGORY = {
  label: 'Group By',
  type: CONDITIONAL_SELECT,
  name: 'category',
  entitySourceField: DATA_MEMBER.name,
};

const GROUP_HEADER_VISIBLE = {
  label: 'Visible',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'groupHeaderVisible',
};

const GROUP_FOOTER_VISIBLE = {
  label: 'Visible',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'groupFooterVisible',
};

const VISIBLE = {
  label: 'Visible',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'visible',
};

const GROUP_FOOTER_SUMMARY_TYPE = {
  label: 'Summary Type',
  type: SELECT,
  values: GROUP_SUMMARY_TYPE_VALUES,
  name: 'groupFooterSummaryType',
};

const GROUP_HEADER_DISPLAY = {
  label: 'Group Display',
  type: CONDITIONAL_SELECT,
  name: 'groupHeaderDisplay',
  entitySourceField: DATA_MEMBER.name,
};

const GROUP_HEADER_SUMMARY_TYPE = {
  label: 'Summary Type',
  type: SELECT,
  values: GROUP_SUMMARY_TYPE_VALUES,
  name: 'groupHeaderSummaryType',
};

const GROUP_HEADER_SUMMARY_COLUMN = {
  label: 'Summary Column',
  type: CONDITIONAL_SELECT,
  name: 'groupHeaderSummaryColumn',
  entitySourceField: DATA_MEMBER.name,
};

const GROUP_FOOTER_SUMMARY_COLUMN = {
  label: 'Summary Column',
  type: CONDITIONAL_SELECT,
  name: 'groupFooterSummaryColumn',
  entitySourceField: DATA_MEMBER.name,
};

const REPEAT_ON_NEW_PAGE = {
  label: 'Repeat On New Page',
  values: YES_NO_CONDITIONAL_VALUES,
  type: CONDITIONAL_SELECT,
  name: 'groupHeaderRepeatOnNewPage',
};

const FOOTER_DISPLAY = {
  label: 'Footer Display',
  type: CONDITIONAL_SELECT,
  name: 'groupFooterDisplay',
  entitySourceField: DATA_MEMBER.name,
};

const THEME = {
  label: 'Theme',
  type: SELECT,
  values: THEME_VALUES,
  name: 'theme',
};

const TREND_THEME = {
  label: 'Theme',
  type: SELECT,
  values: TREND_THEME_VALUES,
  name: 'theme',
};

const GROUP_DATA_MEMBER = {
  label: 'Data Member',
  type: SELECT,
  name: 'groupDataMember',
};

const GROUP_DATA_FIELD = {
  label: 'Data Field',
  type: CONDITIONAL_SELECT,
  name: 'groupDataField',
  entitySourceField: GROUP_DATA_MEMBER.name,
};

const VALUE_DATA_MEMBER = {
  label: 'Value Data member',
  type: SELECT,
  name: 'dataFilterMember',
};

const VALUE = {
  label: 'Value',
  type: CONDITIONAL_SELECT,
  name: 'value',
  entitySourceField: DATA_MEMBER.name,
};

const GROUP_VALUE = {
  label: 'Value',
  type: CONDITIONAL_SELECT,
  name: 'dataFilterField',
  entitySourceField: VALUE_DATA_MEMBER.name,
};

const MARKER_TYPE = {
  label: 'Marker Type',
  type: SELECT,
  values: MARKER_TYPE_VALUES,
  name: 'markerType',
};

const VALUE_LABEL = {
  label: 'Value Label',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'valueLabel',
};

const SHOW_POINT_LABEL = {
  label: 'Show Point Label',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'showPointLabel',
};

const PLOT_DATA_AS_LINE = {
  label: 'Plot Data As Line',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'plotDataAsLine',
};

const VALUE_TYPE = {
  label: 'Value Type',
  type: SELECT,
  values: VALUE_TYPE_VALUES,
  name: 'valueType',
};

const DISPLAY = {
  label: 'Display',
  type: CONDITIONAL_SELECT,
  name: 'categoryLabel',
  entitySourceField: DATA_MEMBER.name,
};

const COLUMN_EXPAND_DIRECTION = {
  label: 'Column Expand Direction',
  type: SELECT,
  values: COLUMN_EXPAND_DIRECTION_VALUES,
  name: 'layoutDirection',
};

const DYNAMIC_CELL = {
  label: 'Dynamic Cell',
  type: SELECT,
  values: DYNAMIC_CELL_VALUES,
  name: 'dynamicCell',
};

const VISIBLE_WHILE_SCROLLING = {
  label: 'Visible While Scrolling',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'visibleWhileScrolling',
};

const SHOW_SUB_TOTAL = {
  label: 'Show Sub Total',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'showSubTotal',
};

const ROW_GROUP_DISPLAY = {
  label: 'Display',
  type: CONDITIONAL_SELECT,
  name: 'rowGroupDisplay',
  entitySourceField: DATA_MEMBER.name,
};

const COLUMN_GROUP_DISPLAY = {
  label: 'Display',
  type: CONDITIONAL_SELECT,
  name: 'columnGroupDisplay',
  entitySourceField: DATA_MEMBER.name,
};

const DISPLAY_TEXT = {
  label: 'Display Text',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'displayText',
};

const PRINT_ON_FIRST_PAGE = {
  label: 'Print On First Page',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'printOnFirstPage',
};

const SHOW_FILTER_CONDITION = {
  label: 'Show Filter Condition',
  type: SELECT,
  values: SHOW_FILTER_VALUES,
  name: 'showFilterCondition',
};

const SHOW_PAGE_NUMBER = {
  label: 'Show Page Number',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'showPageNumber',
};

const SHOW_PRINT_BY_AND_DATE = {
  label: 'Show Print By And Date',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'showPrintByAndDate',
};

const REPORT_TITLE = {
  label: 'Report Title',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'reportTitle',
};

const PRINT_ON_LAST_PAGE = {
  label: 'Print On Last Page',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'printOnLastPage',
};

const LOGO_URL = {
  label: 'Logo Url',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'logoUrl',
};

const PAGE_WIDTH = {
  label: 'Page Width',
  type: SELECT,
  values: PAGE_WIDTH_VALUES,
  name: 'pageWidth',
};

const PAGE_HEIGHT = {
  label: 'Page Height',
  type: SELECT,
  values: PAGE_HEIGHT_VALUES,
  name: 'pageHeight',
};

const SHOW_DISTINCT_VALUES = {
  label: 'Show Distinct Values',
  values: YES_NO_VALUES,
  type: RADIO,
  name: 'distinctValuesOnly',
};

export const PROPERTIES = {
  [REPORT_CONTROL_TYPE.REPORT_INFO]: [
    {
      label: 'Appearance',
      properties: [PAGE_WIDTH, PAGE_HEIGHT, SHOW_DISTINCT_VALUES],
    },
  ],
  [REPORT_CONTROL_TYPE.PAGE_HEADER]: [
    {
      label: 'Appearance',
      properties: [
        REPORT_TITLE,
        VISIBLE,
        PRINT_ON_FIRST_PAGE,
        PRINT_ON_LAST_PAGE,
        SHOW_FILTER_CONDITION,
        SHOW_PAGE_NUMBER,
        SHOW_PRINT_BY_AND_DATE,
        PAGE_HEADER_HEIGHT,
      ],
    },
    {
      label: 'Image',
      properties: [LOGO_URL],
    },
  ],
  [REPORT_CONTROL_TYPE.PAGE_FOOTER]: [
    {
      label: 'Appearance',
      properties: [
        DISPLAY_TEXT,
        VISIBLE,
        PRINT_ON_FIRST_PAGE,
        PRINT_ON_LAST_PAGE,
        SHOW_FILTER_CONDITION,
        SHOW_PAGE_NUMBER,
        SHOW_PRINT_BY_AND_DATE,
      ],
    },
  ],
  [REPORT_CONTROL_TYPE.CROSS_TAB_DATA]: [
    {
      label: 'Appearance',
      properties: [WIDTH],
    },
    {
      label: 'Data',
      properties: [
        { ...DATA_MEMBER, dependentProperties: [CONDITIONAL_DATA_FIELD.name] },
        CONDITIONAL_DATA_FIELD,
        LABEL,
        LINK,
      ],
    },
  ],
  [REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN]: [
    {
      label: 'Appearance',
      properties: [VISIBLE_WHILE_SCROLLING, SHOW_SUB_TOTAL],
    },
    {
      label: 'Data',
      properties: [
        { ...DATA_MEMBER, dependentProperties: [COLUMN_GROUP_DISPLAY.name] },
        CONDITIONAL_DATA_FIELD,
        COLUMN_GROUP_DISPLAY,
        LINK,
        SORT_DIRECTION,
      ],
    },
  ],
  [REPORT_CONTROL_TYPE.CROSS_TAB_ROW]: [
    {
      label: 'Appearance',
      properties: [VISIBLE_WHILE_SCROLLING, SHOW_SUB_TOTAL],
    },
    {
      label: 'Data',
      properties: [
        { ...DATA_MEMBER, dependentProperties: [DATA_FIELD.name, ROW_GROUP_DISPLAY.name] },
        DATA_FIELD,
        ROW_GROUP_DISPLAY,
        LINK,
        SORT_DIRECTION,
      ],
    },
  ],
  [REPORT_CONTROL_TYPE.CROSS_TAB]: [
    {
      label: 'Appearance',
      properties: [MATRIX_TITLE, COLUMN_EXPAND_DIRECTION, DYNAMIC_CELL],
    },
    {
      label: 'Image',
      properties: [IMAGE_URL],
    },
  ],
  [REPORT_CONTROL_TYPE.CHART_GROUP]: [
    {
      label: 'Data',
      properties: [
        { ...DATA_MEMBER, dependentProperties: [CATEGORY.name, DISPLAY.name] },
        CATEGORY,
        DISPLAY,
        SORT_DIRECTION,
      ],
    },
  ],
  [REPORT_CONTROL_TYPE.CHART_VALUE]: [
    {
      label: 'Appearance',
      properties: [VALUE_LABEL, SHOW_POINT_LABEL, PLOT_DATA_AS_LINE],
    },
    {
      label: 'Data',
      properties: [{ ...DATA_MEMBER, dependentProperties: [VALUE.name] }, VALUE_TYPE, VALUE, LINK],
    },
  ],
  [REPORT_CONTROL_TYPE.GROUP_TREND]: [
    {
      label: 'Data',
      properties: [
        { ...GROUP_DATA_MEMBER, dependentProperties: [GROUP_DATA_FIELD.name] },
        GROUP_DATA_FIELD,
        { ...VALUE_DATA_MEMBER, dependentProperties: [GROUP_VALUE.name] },
        GROUP_VALUE,
        LABEL,
        TRANSLATED_LABEL,
      ],
    },
    {
      label: 'Appearance',
      properties: [WIDTH, MARKER_TYPE, TREND_THEME],
    },
  ],
  [REPORT_CONTROL_TYPE.GROUP_HEADER]: [
    {
      label: 'Group Header',
      properties: [
        {
          ...DATA_MEMBER,
          dependentProperties: [
            GROUP_BY_COLUMN.name,
            GROUP_HEADER_DISPLAY.name,
            GROUP_HEADER_SUMMARY_COLUMN.name,
            GROUP_FOOTER_SUMMARY_COLUMN.name,
            FOOTER_DISPLAY.name,
          ],
        },
        GROUP_BY_COLUMN,
        GROUP_HEADER_VISIBLE,
        GROUP_HEADER_DISPLAY,
        SORT_DIRECTION,
        GROUP_HEADER_SUMMARY_TYPE,
        GROUP_HEADER_SUMMARY_COLUMN,
        REPEAT_ON_NEW_PAGE,
      ],
    },
    {
      label: 'Group Footer',
      properties: [
        GROUP_FOOTER_VISIBLE,
        FOOTER_DISPLAY,
        GROUP_FOOTER_SUMMARY_TYPE,
        GROUP_FOOTER_SUMMARY_COLUMN,
      ],
    },
    {
      label: 'Appearance',
      properties: [THEME],
    },
  ],
  [REPORT_CONTROL_TYPE.DATA_COLUMN]: [
    {
      label: 'Data',
      properties: [
        { ...DATA_MEMBER, dependentProperties: [DATA_FIELD.name] },
        DATA_FIELD,
        LABEL,
        TRANSLATED_LABEL,
        LINK,
      ],
    },
    {
      label: 'Appearance',
      properties: [WIDTH, FORMAT, COLOR, BACKGROUND_COLOR, FONT_FAMILY],
    },
    {
      label: 'Image',
      properties: [IMAGE_URL],
    },
  ],
  [REPORT_CONTROL_TYPE.CHART]: [
    {
      label: 'Appearance',
      properties: [
        CHART_TYPE,
        TITLE,
        CHART_HEIGHT,
        SHOW_LEGEND,
        LEGEND_LAYOUT,
        LEGEND_PLACEMENT,
        LEGEND_POSITION,
        PALETTE,
        SHOW_GRID_LINE,
        ENABLE_3D,
      ],
    },
    {
      label: 'Behavior',
      properties: [
        DYNAMIC_SERIES,
        { ...DATA_MEMBER, dependentProperties: [SERIES_VALUE.name] },
        SERIES_VALUE,
        SORT_DIRECTION,
      ],
    },
  ],
};
